import Layout from '../components/Layout/Layout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

import Overview from '../components/Views/Dashboard/Overview.vue'
import Widgets from '../components/Views/Dashboard/Widgets.vue'
import Welcome from '../components/Views/Dashboard/Welcome.vue'
import SampleSheet from '../components/Views/Dashboard/SampleSheet.vue'

import Charts from '../components/Views/Charts.vue'


//  pages
// const Overview = () =>
// import ( /* webpackChunkName: "widgets" */ 'src/components/Views/Dashboard/Overview.vue')
// const Widgets = () =>
// import ( /* webpackChunkName: "widgets" */ 'src/components/Views/Dashboard/Widgets.vue')
// const Welcome = () =>
// import ( /* webpackChunkName: "widgets" */ 'src/components/Views/Dashboard/Welcome.vue')
// Pages
import User from 'src/components/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Views/Pages/Login.vue'
import Registration from 'src/components/Views/Pages/Registration.vue'
import JoinSubject from 'src/components/Views/Pages/JoinSubject.vue'
import Lock from 'src/components/Views/Pages/Lock.vue'

import ProjectsInternal from 'src/components/Views/Projects/Internal.vue'
import ProjectsExternal from 'src/components/Views/Projects/External.vue'

import ExaminationsMyWorkflow from 'src/components/Views/Examinations/MyWorkflow.vue'
import ExaminationsMySubject from 'src/components/Views/Examinations/MySubject.vue'

import PatientsAll from 'src/components/Views/PatientsAll.vue'
import Statim from 'src/components/Views/Patients/Statim.vue'
import ByVariant from 'src/components/Views/Patients/ByVariant.vue'

import VariantsAll from 'src/components/Views/Variants/VariantsAll.vue'

import AnWorkflows from 'src/components/Views/Analyses/AnWorkflows.vue'
import AnGenes from 'src/components/Views/Analyses/AnGenes.vue'

import Accounts from 'src/components/Views/Settings/Accounts.vue'
import Workflows from 'src/components/Views/Settings/Workflows.vue'

import Sources from 'src/components/Views/Links/Sources.vue'

import ReportsFullList from 'src/components/Views/Reports/FullList.vue'

import FavoritesFullList from 'src/components/Views/Favorites/FullList.vue'

import StartChat from 'src/components/Views/Chat/StartChat.vue'

import BlankPage from 'src/components/Views/BlankPage.vue'

// Components pages
import Buttons from 'src/components/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Views/Components/GridSystem.vue'
import Panels from 'src/components/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Views/Components/Notifications.vue'
import Icons from 'src/components/Views/Components/Icons.vue'
import Typography from 'src/components/Views/Components/Typography.vue'

// Forms pages
// const RegularForms = () =>
//     import ( /* webpackChunkName: "forms" */ 'src/components/Views/Forms/RegularForms.vue')
// const ExtendedForms = () =>
//     import ( /* webpackChunkName: "forms" */ 'src/components/Views/Forms/ExtendedForms.vue');
// const ValidationForms = () =>
//     import ( /* webpackChunkName: "forms" */ 'src/components/Views/Forms/ValidationForms.vue')
// const Wizard = () =>
//     import ( /* webpackChunkName: "forms" */ 'src/components/Views/Forms/Wizard.vue');

// TableList pages
// const RegularTables = () =>
//     import ( /* webpackChunkName: "tables" */ 'src/components/Views/Tables/RegularTables.vue');
// const ExtendedTables = () =>
//     import ( /* webpackChunkName: "tables" */ 'src/components/Views/Tables/ExtendedTables.vue');
// const PaginatedTables = () =>
//     import ( /* webpackChunkName: "tables" */ 'src/components/Views/Tables/PaginatedTables.vue');
// Maps pages

// Calendar
import Calendar from 'src/components/Views/Calendar/CalendarRoute.vue'
// Charts
// const Charts = () =>
// import ( /* webpackChunkName: "widgets" */ 'src/components/Views/Charts.vue')


let projectsMenu = {
    path: '/projects',
    component: Layout,
    redirect: '/projects/internal',
    children: [{
            path: 'internal',
            name: 'ProjectsInternal',
            component: ProjectsInternal
        },
        {
            path: 'external',
            name: 'ProjectsExternal',
            component: ProjectsExternal
        },
    ]
}

let examinationsMenu = {
    path: '/examinations',
    component: Layout,
    redirect: '/examinations/myworkflow',
    children: [{
            path: 'myworkflow',
            name: 'ExaminationsMyWorkflow',
            component: ExaminationsMyWorkflow
        },
        {
            path: 'mysubject',
            name: 'ExaminationsMySubject',
            component: ExaminationsMySubject
        },
    ]
}

let patientsMenu = {
    path: '/patients',
    component: Layout,
    redirect: '/patients/patientsall',
    children: [{
            path: 'patientsall',
            name: 'PatientsAll',
            component: PatientsAll
        },
        {
            path: 'statim',
            name: 'Statim',
            component: Statim
        },
        {
            path: 'byvariant',
            name: 'ByVariant',
            component: ByVariant
        },
    ]
}

let variantsMenu = {
    path: '/variants',
    component: Layout,
    redirect: '/variants/variantsall',
    children: [{
        path: 'variantsall',
        name: 'VariantsAll',
        component: VariantsAll
    }, ]
}

let analysesMenu = {
    path: '/analyses',
    component: Layout,
    redirect: '/analyses/workflows',
    children: [{
            path: 'anworkflows',
            name: 'AnWorkflows',
            component: AnWorkflows
        },
        {
            path: 'angenes',
            name: 'AnGenes',
            component: AnGenes
        },
    ]
}

let settingsMenu = {
    path: '/settings',
    component: Layout,
    redirect: '/settings/accounts',
    children: [{
            path: 'accounts',
            name: 'Accounts',
            component: Accounts
        },
        {
            path: 'workflows',
            name: 'Workflows',
            component: Workflows
        },
    ]
}

let favoritesMenu = {
    path: '/favorites',
    component: Layout,
    redirect: '/favorites/fulllist',
    children: [{
        path: 'fulllist',
        name: 'FavoritesFullList',
        component: FavoritesFullList
    }, ]
}

let reportsMenu = {
    path: '/reports',
    component: Layout,
    redirect: '/reports/fulllist',
    children: [{
        path: 'fulllist',
        name: 'ReportsFullList',
        component: ReportsFullList
    }, ]
}

let chatMenu = {
    path: '/chat',
    component: Layout,
    redirect: '/chat/startchat',
    children: [{
        path: 'startchat',
        name: 'StartChat',
        component: StartChat
    }, ]
}

let linksMenu = {
    path: '/links',
    component: Layout,
    redirect: '/links/sources',
    children: [{
            path: 'sources',
            name: 'Sources',
            component: Sources
        },

    ]
}


let pagesMenu = {
    path: '/pages',
    component: Layout,
    redirect: '/pages/user',
    children: [{
            path: 'user',
            name: 'User Page',
            component: User
        },
        {
            path: 'timeline',
            name: 'Timeline Page',
            component: TimeLine
        },
        {
            path: 'login',
            name: 'Login page',
            component: Login
        }
    ]
}

// let loginPage = {
//     path: '/login',
//     name: 'Login',
//     component: Login
// }

// let loginPage = {
//     path: '#/login',
//     component: Layout,
//     redirect: '/login/sign_in',
//     children: [{
//             path: 'login',
//             name: 'Login Page',
//             component: Login
//         },
//         // {
//         //     path: 'timeline',
//         //     name: 'Timeline Page',
//         //     component: TimeLine
//         // }
//     ]
// }


let lockPage = {
    path: '/lock',
    name: 'Lock',
    component: Lock
}


const routes = [{
        path: '/',
        redirect: 'welcome',
        component: Layout,
        children: [{
                path: 'welcome',
                name: 'Welcome',
                component: Welcome
            },
            {
                path: 'registration',
                name: 'Registration',
                component: Registration
            },
            {
                path: 'join_subject',
                name: 'JoinSubject',
                component: JoinSubject
            },
            {
                path: 'examination_sheet',
                name: 'SampleSheet',
                component: SampleSheet
            },
        ]
    },
    projectsMenu,
    examinationsMenu,
    patientsMenu,
    variantsMenu,
    analysesMenu,
    settingsMenu,
    favoritesMenu,
    reportsMenu,
    chatMenu,
    linksMenu,
    // loginPage,
    lockPage,
    {
        path: '/admin',
        component: Layout,
        redirect: '/admin/overview',
        children: [{
                path: 'overview',
                name: 'Overview',
                component: Overview
            },
            {
                path: 'widgets',
                name: 'Widgets',
                component: Widgets
            },
            {
                path: 'my_profile',
                name: 'My Profile',
                component: User
            },
        ]
    },
    { path: '*', component: NotFound }
];

export default routes